import { createFileRoute, redirect } from "@tanstack/react-router";

/** The old address of Move-in packets' Fields and preview tab, form and view kept. */
export const Route = createFileRoute("/_authenticated/_administration/settings/admission-forms")({
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/settings/move-in/fields", search, replace: true });
  },
});
